import { Navigate, useLocation } from 'react-router-dom';

function SignIn() {
  const location = useLocation();
  const searchParams = new URLSearchParams(window.location.search);
  const state = location.state as { email?: string } | null;
  const email = searchParams.get('email') || state?.email || '';
  return <Navigate to="/welcome" replace state={{ email }} />;
}

export default SignIn;
